module.exports = __webpack_public_path__ + "static/media/ic_left_active.f38f12b8.svg";